import { render, staticRenderFns } from "./CampaignCardCreate.vue?vue&type=template&id=779b322a&scoped=true&"
import script from "./CampaignCardCreate.vue?vue&type=script&lang=js&"
export * from "./CampaignCardCreate.vue?vue&type=script&lang=js&"
import style0 from "./CampaignCardCreate.vue?vue&type=style&index=0&id=779b322a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779b322a",
  null
  
)

export default component.exports